import React from 'react';
import { RetailersProxy } from '../services/catalogServiceAPI/retailersProxy';
import { Form, Input, Button, Typography, notification } from 'antd';

const { Title } = Typography;

export class CreateRetailer extends React.Component {
    retailersProxy = new RetailersProxy();
    state = { submitting: false };

    add = async (values) => {
        this.setState({ submitting: true });
        try {
            await this.retailersProxy.create(values);
            notification.success({ message: 'Retailer created' });
        } catch {
            notification.error({ message: 'Failed to create retailer' });
        } finally {
            this.setState({ submitting: false });
        }
    }

    render() {
        return (
            <div style={{ padding: 24, maxWidth: 480 }}>
                <Title level={3}>Create Retailer</Title>
                <Form layout="vertical" onFinish={this.add} requiredMark={false}>
                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="description">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Logo" name="logo">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Homepage" name="homepage">
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={this.state.submitting}
                            style={{ background: '#7b6ef6', borderColor: '#7b6ef6' }}
                        >
                            Add Retailer
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}
